import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import GradientSeparator from '../components/GradientSeparator';

const imageContext = require.context('../public/banner', false, /\.(png|jpe?g|svg)$/i);
const images = imageContext.keys().map(imageContext);

const Home = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Cambia la imagen cada 5 segundos
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const element = document.getElementById(hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <div>
      {/* Banner Rotativo */}
      <div className="relative w-full h-[75vh] overflow-hidden">
        <AnimatePresence initial={false}>
          <motion.img
            key={currentImageIndex}
            src={images[currentImageIndex]}
            alt={images[currentImageIndex]}
            className="absolute inset-0 w-full h-full object-cover"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
          />
        </AnimatePresence>
        <div className="absolute inset-0 bg-black bg-opacity-50 flex items-end justify-end p-8 md:p-12">
          <motion.h2
            className="text-white text-xl md:text-2xl font-bold text-right leading-tight"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
          >
            "Somos una empresa dedicada a la construcción"<br />
            Calidad que perdura, construcciones que inspiran...<br />
            <i>SEDOM empresas</i>
          </motion.h2>
        </div>
      </div>

      {/* Botón Ver Proyectos */}
      <div className="flex justify-center py-8 bg-gray-50">
        <Link to="/servicios#proyectos">
          <motion.button
            className="bg-caterpillar-yellow hover:bg-caterpillar-yellow-dark text-white font-bold py-3 px-8 rounded-lg shadow-lg transition duration-300 transform hover:scale-105"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Ver Proyectos
          </motion.button>
        </Link>
      </div>

      {/* Sección Sobre Nosotros */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <motion.h2
            className="text-4xl font-bold text-center text-gray-800 mb-12"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.6 }}
          >
            Sobre Nosotros
          </motion.h2>
          <div className="max-w-3xl mx-auto text-lg text-gray-700 leading-relaxed text-center">
            <motion.p
              className="mb-6"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              En SEDOM Empresa, nos dedicamos a la excelencia en cada proyecto de construcción. Con años de experiencia en el sector, hemos consolidado nuestra reputación como líderes en obras civiles y eléctricas, entregando soluciones innovadoras y de alta calidad que superan las expectativas de nuestros clientes.
            </motion.p>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              Nuestro compromiso es con la seguridad, la eficiencia y la sostenibilidad, asegurando que cada estructura que construimos no solo sea funcional y estéticamente agradable, sino también respetuosa con el medio ambiente y duradera en el tiempo. Confíe en SEDOM para hacer realidad sus proyectos más ambiciosos.
            </motion.p>
          </div>
        </div>
      </section>

      <GradientSeparator />

      {/* Grilla de Clientes */}
      <section id="clientes" className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <motion.h2
            className="text-4xl font-bold text-center text-gray-800 mb-12"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.6 }}
          >
            Nuestros Clientes
          </motion.h2>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 items-center justify-items-center">
            {((r) => {
              return r.keys().map((item, index) => (
                <motion.img
                  key={index}
                  src={r(item)}
                  alt={`Cliente ${index + 1}`}
                  className="w-full h-auto object-contain grayscale hover:grayscale-0 transition-all duration-300"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                />
              ));
            })(require.context('../public/img', false, /\.(png|jpe?g|svg)$/i))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;